import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'TitleDivider',
  props: {
    width: { default: "310px" }
  },
  setup(__props: any) {

/* eslint-disable */
// @ts-nocheck


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "title-divider mt-1",
    style: _normalizeStyle({ width: __props.width }),
    role: "presentation",
    "aria-hidden": "true"
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("i", { class: "bi bi-stars" }, null, -1)
  ]))], 4))
}
}

})